enum MessageAuthor {
  USER = 'USER',
  ASSISTANT = 'ASSISTANT',
}

export default MessageAuthor;
